"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PoweredByBytehogs = void 0;

var _react = _interopRequireDefault(require("react"));

var PoweredByBytehogs = function PoweredByBytehogs(props) {
  var white = props.white,
      landscape = props.landscape;
  return /*#__PURE__*/_react.default.createElement("img", {
    src: "https://client-upload.bytehogs.com/bhg/brand/powered_by_bytehogs".concat(landscape ? "_landscape" : "").concat(white ? "_white" : "", ".svg"),
    className: "powered-by-bytehogs " + (landscape ? "landscape" : "")
  });
};

exports.PoweredByBytehogs = PoweredByBytehogs;
PoweredByBytehogs.defaultProps = {
  white: false,
  landscape: false
};